import React from 'react';
import './App.css';
import AppBackground from "./components/background";
import { createBrowserRouter, Navigate, RouterProvider } from "react-router";
import AppChrome from "./layouts/AppChrome";
import HomePage from "./pages/home";
import SelectDevicePage from "./pages/select-device";
import InstructionPage from "./pages/instruction";
import AccountPage from "./pages/account";
import { DataProvider } from './context/dataProvider';
import SettingsPage from './pages/settings';
import SettingsEndPage from './pages/settings-end';
import SelectTariffPage from './pages/select-tariff';
import BuySuccessPage from './pages/buy-success';
import PrivacePolicyPage from './pages/documents/privacy-policy-page';
import UserAgreementPage from './pages/documents/user-agreement';
import AgreementPage from './pages/documents/agreement';
import OfferPage from './pages/documents/offer';
import HistoryPage from './pages/history';
import { TelegramInit } from './components/TelegramInit';
import BuyFailPage from './pages/buy-fail';
import DeviceFailPage from './pages/device-fail';
import SubscriptionFailPage from './pages/subscription-fail';
import FailPage from './pages/fail';
import BuyConfirmationPage from './pages/buy-confirmation';
import DevicesPage from './pages/devices';
import FaqPage from './pages/faq';
import FaqCategoryPage from './pages/faq/category';
import { StylesProvider } from './context/stylesContext';
import { AuthProvider } from './context/authContext';
import { ProtectedRoute } from './components/ProtectedRoute';
import LoginEmailPage from './pages/login';
import LoginCodePage from './pages/login/code';
import LoginMethodsPage from './pages/login-methods';
import LinkEmailPage from './pages/link-email';
import LinkEmailCodePage from './pages/link-email/code';
import LinkEmailSuccessPage from './pages/link-email-success';

const withProtected = (element: React.ReactNode) => (
  <ProtectedRoute>{element}</ProtectedRoute>
);

const router = createBrowserRouter([
  {
    path: '/login',
    element: <LoginEmailPage />,
  },
  {
    path: '/login/code',
    element: <LoginCodePage />,
  },
  {
    path: '/',
    element: <AppChrome />,
    errorElement: <FailPage />,
    children: [
      {
        index: true,
        element: withProtected(<HomePage />),
      },
      {
        path: 'select-device',
        element: withProtected(<SelectDevicePage />),
      },
      {
        path: 'instruction',
        element: withProtected(<InstructionPage />),
      },
      {
        path: 'account',
        element: withProtected(<AccountPage />),
      },
      {
        path: 'account/login-methods',
        element: withProtected(<LoginMethodsPage />),
      },
      {
        path: 'account/login-methods/link-email',
        element: withProtected(<LinkEmailPage />),
      },
      {
        path: 'account/login-methods/link-email/code',
        element: withProtected(<LinkEmailCodePage />),
      },
      {
        path: 'account/login-methods/link-email/success',
        element: withProtected(<LinkEmailSuccessPage />),
      },
      {
        path: 'settings',
        element: withProtected(<SettingsPage />),
      },
      {
        path: 'settings-end',
        element: withProtected(<SettingsEndPage />),
      },
      {
        path: 'select-tariff',
        element: withProtected(<SelectTariffPage />),
      },
      {
        path: 'payment/success',
        element: withProtected(<BuySuccessPage />),
      },
      {
        path: 'payment/confirmation',
        element: withProtected(<BuyConfirmationPage />),
      },
      {
        path: 'payment/fail',
        element: withProtected(<BuyFailPage />),
      },
      // Документы доступны без авторизации (на странице логина могут быть ссылки на оферту и т.п.)
      {
        path: 'privacy-policy',
        element: <PrivacePolicyPage />,
      },
      {
        path: 'user-agreement',
        element: <UserAgreementPage />,
      },
      {
        path: 'agreement',
        element: <AgreementPage />,
      },
      {
        path: 'offer',
        element: <OfferPage />,
      },
      {
        path: 'history',
        element: withProtected(<HistoryPage />),
      },
      {
        path: 'devices',
        element: withProtected(<DevicesPage />),
      },
      {
        path: 'faq',
        element: withProtected(<FaqPage />),
      },
      {
        path: 'faq/:slug',
        element: withProtected(<FaqCategoryPage />),
      },
      {
        path: 'device-fail',
        element: withProtected(<DeviceFailPage />),
      },
      {
        path: 'subscription-fail',
        element: withProtected(<SubscriptionFailPage />),
      },
      {
        path: 'error',
        element: <FailPage />,
      },
      {
        path: '*',
        element: <Navigate to="/" replace />,
      },
    ],
  },
]);

function App() {
  return (
    <TelegramInit onInit={(isTelegram, username) => console.log('Is Telegram:', isTelegram, 'Username:', username)}>
      <AuthProvider>

        {/* чувак, ниже мы используем общие переменные, а здесь мы условно спрашиваем у пользака, какой у него язык */}
        <DataProvider>
          <StylesProvider>
            <div className="App">
              <AppBackground />
              <RouterProvider router={router} />
            </div>
          </StylesProvider>
        </DataProvider>
      </AuthProvider>
    </TelegramInit>
  );
}

export default App;
